<template>
  <BaseLayout>
    <router-view/>
  </BaseLayout>
</template>

<script>
import BaseLayout from './layouts/BaseLayout.vue';
import '@/assets/scss/null.scss';
import '@/assets/scss/adaptation-settings.scss';
import '@/assets/scss/my-home-page.scss';

export default {
  name: 'App',

  components: {
    BaseLayout
  }
}

</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

@font-face {
  font-family: 'DeusEx';
  src: url('@/assets/fonts/deusex.otf') format('truetype');
}

body {
  font-family: 'DeusEx';
  background-color: #1B1C22;
}

* {
  font-family: 'DeusEx';
}
</style>
